import { cloudApi } from '../api/index';
import {
  ROOM_TYPE,
  ONE_DAY,
  formatTime,
  TO_DAY,
  statTxt,
  toFixed,
} from '../base/CONST';
const levelImg1 = require('../images/common/server1.svg');
const levelImg2 = require('../images/common/server2.svg');
const levelImg3 = require('../images/common/server3.svg');
const levelImg4 = require('../images/common/server4.svg');
const { getCloudConfig, cloudBuy, cloudRenew } = cloudApi;
// 0：未过期 1：已过期 2：包含 0&1
// const SERV_TIME_STATE = {
//   USING: 0,
//   EXPIRED: 1,
//   BOTH: 2,
// }
// true：同等级 false：不同等级
const SERV_LEVEL = {
  SAME: true,
  BOTH: false,
};
// 0：升级 1：续费 2：降级 3：可升级可续费, 4：包含0-1-2
const OPT_TYPE = {
  UPGRADE: 0,
  RENEW: 1,
  DEMOTION: 2,
  UPGRADE_OR_RENEW: 3,
  ALL: 4,
};

export default {
  props: {
    currServs: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      dialogTableVisible: false,
      ROOM_TYPE,
      buyCount: 1,
      buyedCount: 0,
      buyLimit: 40,
      min: 1,
      price: [],
      day: [],
      levelImg1,
      levelImg2,
      levelImg3,
      levelImg4,
      selectedIndex: -1,
      selectedName: '',
      days: 30,
      agreeProto: false,
      currItem: {
        player_max: 0,
        rmb: 0,
        room_type: 1,
        sub_rmb: 0,
        sub_rmb_txt: '',
      },
      totalPrice: 0,
      subPrice: 0,
      totalPriceLoading: false,
      miniLevel: 4,
      currServs4Display: [],
      noAnyChance: false,
      showTip: false
    };
  },
  created() {
    const TYPE = this.$route.params.type;
    if (this.currServs.length) {
      this.currServs4Display = this.currServs.slice(0, 2);
      console.log('serverOrder.mixins created', this.currServs4Display);
      this.currServs.forEach(serv => {
        if (serv.room_type < this.miniLevel) this.miniLevel = serv.room_type;
      });
      if (this.getOptType() === OPT_TYPE.RENEW) {
        this.miniLevel = 5; // 续费，全部类型不可选择
      }
      if (this.isSameLevel) {
        this.currItem = this.currServs[0];
        this.setCurrSinglePrice(this.currServs[0]);
      }
      this.buyCount = this.currServs.length;
    } else {
      this.miniLevel = 1;
    }
    getCloudConfig().then(res => {
      if (res.code === 0) {
        const { buy_limit, day, price, buy_count } = res.data;
        this.buyedCount = TYPE === 'renew' ? 0 : buy_count;
        this.buyLimit = buy_limit;
        this.day = day;
        this.price = (price || []).map(price => {
          price.singlePrice = price.sub_rmb || price.rmb;
          return price;
        });
        if (this.currItem) {
          const THE_RIGHT_ONE = this.price.filter(
            price => price.room_type === this.currItem.room_type,
          )[0];
          this.currItem = THE_RIGHT_ONE;
          this.setCurrSinglePrice(THE_RIGHT_ONE);
        }
        if (
          this.currServs.length &&
          this.getOptType() === OPT_TYPE.UPGRADE_OR_RENEW &&
          !this.expiredLen
        ) {
          this.day.unshift(0);
        }
        // if (this.miniLevel === 5 || this.isSameLevel) {
        // }
        this.selectedIndex = this.miniLevel - 1;
        this.selectedName = ROOM_TYPE[this.currItem.room_type];
        this.getTotalPrice();
      }
    });
  },
  mounted() {
    // this.showTip = true; // 功能已上线，屏蔽提示
  },
  watch: {
    days: function () {
      console.log('days change---');
      if (
        (this.currItem.rmb && this.buyCount) ||
        this.miniLevel === 5 ||
        this.isSameLevel
      ) {
        this.getTotalPrice();
      } else {
        this.setTotalPrice(0, 0);
      }
      this.setCurrSinglePrice(this.currItem);
    },
    buyCount: function (val) {
      console.log(
        'buyCount change---',
        val,
        this.currItem,
        this.currServs.length,
      );
      if (this.currItem.rmb) {
        this.getTotalPrice();
      } else {
        this.setTotalPrice(0, 0);
      }
    },
  },
  computed: {
    usingLen: function () {
      return this.currServs.filter(ser => ser.expire_time * 1000 > TO_DAY)
        .length;
    },
    expiredLen: function () {
      return this.currServs.filter(ser => ser.expire_time * 1000 <= TO_DAY)
        .length;
    },
    isSameLevel: function () {
      const servArr = [0, 0, 0, 0, 0];
      this.currServs.forEach(serv => {
        servArr[serv.room_type] = 1;
      });
      return servArr.reduce((prevVal, currVal) => prevVal + currVal, 0) > 1
        ? SERV_LEVEL.BOTH
        : SERV_LEVEL.SAME;
    },
    hideForm: function () {
      return this.noAnyChance || !this.totalPrice;
    },
  },
  methods: {
    getOptType() {
      console.log(
        'getOptType---',
        this.usingLen,
        this.expiredLen,
        this.isSameLevel,
      );
      let optType = -1;
      if (this.usingLen) {
        optType = this.isSameLevel ? OPT_TYPE.UPGRADE_OR_RENEW : OPT_TYPE.RENEW;
        // if (this.expiredLen) {
        //   // optType = OPT_TYPE.RENEW
        //   optType = this.isSameLevel ? OPT_TYPE.UPGRADE_OR_RENEW : OPT_TYPE.RENEW
        // }
      } else {
        optType = OPT_TYPE.ALL;
      }
      return optType;
    },
    getLevelImg(level = 1) {
      return this['levelImg' + level];
    },
    handleServerClick(item, index) {
      if (
        item.room_type < this.miniLevel ||
        item.room_type === this.currItem.room_type
      ) {
        return false;
      }
      this.selectedIndex = index;
      this.selectedName = ROOM_TYPE[item.room_type];
      this.currItem = item;
      this.setCurrSinglePrice(item);
      this.getTotalPrice();
    },
    setCurrSinglePrice(item) {
      const count = Math.floor(this.days / 30);
      const orgPrice = item.rmb * count;
      this.currItem.singlePrice = '¥' + toFixed(orgPrice);
      this.currItem.singlePriceDesc = item.sub_rmb_txt
        ? `（原价¥${toFixed(orgPrice)}，限时折扣价¥${toFixed(
            item.sub_rmb * count,
          )}）`
        : '';
    },
    getTotalPrice() {
      this.totalPriceLoading = true;
      let RequestFn = cloudBuy;
      const params = { day: this.days, cost: 1 };
      if (this.getOptType() !== OPT_TYPE.RENEW || this.currServs.length === 1) {
        params.room_type = this.currItem.room_type;
      }
      if (this.currServs.length) {
        RequestFn = cloudRenew;
        params.ids = this.currServs.map(serv => serv.id).join(',');
      } else {
        params.buy_count = this.buyCount;
      }
      RequestFn(params)
        .then(res => {
          this.totalPriceLoading = false;
          if (res.code === 0) {
            this.totalPrice = toFixed(res.data.money);
            this.subPrice = res.data.sub_money
              ? toFixed(res.data.sub_money)
              : 0;
          }
        })
        .catch(reason => {
          if (reason.code === 134 && this.buyCount === 1) {
            this.noAnyChance = true;
            const tips = parseInt(this.buyLimit, 10)
              ? `您最多可购买${this.buyLimit}台服务器，不可再次购买，请前往续费或升级哦~`
              : '您还不是开发者，无法购买服务器。请先成为开发者~';
            this.$message ? this.$message.error(tips) : this.$toast.fail(tips);
          }
        });
    },
    setTotalPrice(totalPrice, subPrice) {
      this.totalPrice = totalPrice;
      this.subPrice = subPrice;
    },
    getServsTxt() {
      const len = this.currServs.length;
      console.log('getServsTxt---', len);
      if (len) {
        // 升级续费
        if (len === 1) {
          return ROOM_TYPE[this.currItem.room_type] + 'x1';
        } else if (this.isSameLevel) {
          return ROOM_TYPE[this.currItem.room_type] + `x${len}`;
        } else {
          return `混合服务器x${len}`;
        }
      } else {
        // 全新购买
        return ROOM_TYPE[this.currItem.room_type] + `x${this.buyCount}`;
      }
    },
    handleSubmit() {
      let RequestFn = cloudBuy;
      const params = { day: this.days, cost: 0 };
      if (this.getOptType() !== OPT_TYPE.RENEW || this.currServs.length === 1) {
        params.room_type = this.currItem.room_type;
      }
      if (this.currServs.length) {
        RequestFn = cloudRenew;
        params.ids = this.currServs.map(serv => serv.id).join(',');
      } else {
        params.buy_count = this.buyCount;
      }
      RequestFn(params).then(res => {
        console.log('提交订单', res);
        if (res.code === 0) {
          res.data.count = res.data.count || this.buyCount;
          res.data.txt = res.data.txt || this.getServsTxt();
          res.data.title = this.currServs.length ? '升级/续费' : '购买';
          this.$router.push({
            name: 'cloudServerPay',
            params: res.data,
            query: { id: res.data.id },
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
  filters: {
    remainderTime(expiredTime) {
      if (('' + expiredTime).length < 13) expiredTime *= 1000;
      const _remainderTime = expiredTime - Date.now();
      let remainderDay = Math.round(_remainderTime / ONE_DAY);
      remainderDay = remainderDay <= 0 ? 0 : remainderDay;
      return `${remainderDay}天（${formatTime(expiredTime)}到期）`;
    },
    roomType(type) {
      return ROOM_TYPE[type];
    },
    getStat(stat) {
      return statTxt[stat];
    },
    toFixed(number) {
      return toFixed(number);
    },
  },
};
